import { AccessCodeModel } from 'api/dto/AccessCode.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'accessCode';

export namespace AccessCodeState {
  export type ListResource = Resource<AccessCodeModel[]>;

  export type Domain = {
    unsubscribedResource?: ListResource;
    searchResource?: ListResource;
  };

  export const INITIAL_LIST_RESOURCE: ListResource =
    Resource.createPendingResource<AccessCodeModel[]>();
  export const INITIAL_DOMAIN: Domain = {
    unsubscribedResource: INITIAL_LIST_RESOURCE,
    searchResource: INITIAL_LIST_RESOURCE,
  };
}
